<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-half pt-0 specific text-center">
        <p
          :class="`text-center mx-3 ${
            $root.selectedLanguage === `ta`
              ? `ta-line`
              : $root.selectedLanguage === `si`
              ? `si-line`
              : `en-line`
          }`"
        >
          {{ $root.selectedLanguageData.welcome }}
        </p>
        <p
          :class="`${
            $root.selectedLanguage === `ta`
              ? `ta-sub-line`
              : $root.selectedLanguage === `si`
              ? `si-sub-line`
              : `en-sub-line`
          }`"
        >
          {{ $root.selectedLanguageData.onlineaccountopeningapplication }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped></style>
